<template>
  <div :style="{ padding: '0 50px', marginTop: '64px', zIndex: 1 }">
    <div :style="{ background: 'white !important', padding: '24px', minHeight: '880px' }">
      <MigrateBarChart />
      
          <!-- <a-button id="china-btn" class="china-btn-color" >China</a-button>
          <a-button id="japan-btn" class="japan-btn-color" >Japan</a-button>
          <a-button id="italy-btn" class="italy-btn-color" >Italy</a-button>
          <a-button id="finland-btn" class="finland-btn-color">Finland</a-button>
          <a-button id="france-btn" class="france-btn-color" >France</a-button>
          <a-button id="spain-btn" class="spain-btn-color" >Spain</a-button>
          <a-button id="uk-btn" class="uk-btn-color">UK</a-button>
          <a-button id="canada-btn" class="canada-btn-color" >Canada</a-button>
          <a-button id="us-btn" class="us-btn-color">United States</a-button>
          <a-button id="australia-btn" class="australia-btn-color" >Australia</a-button>
          <a-button id="iceland-btn" class="iceland-btn-color" >Iceland</a-button>
          <a-button id="chile-btn" class="chile-btn-color" >Chile</a-button>
          <a-button id="turkey-btn" class="turkey-btn-color" >Turkey</a-button>
          <a-button id="mexico-btn" class="mexico-btn-color" >Mexico</a-button> -->
    </div>
  </div>
</template>

<script>

import MigrateBarChart from "../components/effort/migrateBarChart.vue"

export default {
  name: "Effort",
  components:{
    MigrateBarChart,
  }
};
</script>

<style scoped>

</style>